module.exports = {
  "country": "MC",
  "artist": "Severine",
  "song": "Un Banc, Un arbre, une rue",
  "year": "1971",
  "place": "1",
  "spotify": "0OInqhDtfYPcSpEQNtJx3n"
};